import _ from 'lodash';
import React, { cloneElement, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { sendNotesLog } from '../../../../../../../api/questionAPI';
import { URL } from '../../../../../../../constant';
import { checkAnswerAction, setAnsweringQuestionsAction } from '../../../../../../../redux/answeringQuestions/answeringQuestions';


function MultipleChoiceQuestion(props) {
  const dispatch = useDispatch();
  const checkAnswer = () => { dispatch(checkAnswerAction()) };
  const answeringQuestions = useSelector(state => state.answeringQuestions);
  const setAnsweringQuestions = payload => { dispatch(setAnsweringQuestionsAction(payload)) };

  const [questions, setQuestions] = useState(null);
  const [answerView, setAnswerView] = useState([]);
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    setQuestions([]);
    setAnswerView([]);
    setAnswers([]);
    handleQestionRandom();

    setAnsweringQuestions({ multipleAnswer: null});
  }, [answeringQuestions.data]);

  const handleQestionRandom = useCallback(() => {
    if (!answeringQuestions.data || answeringQuestions.data.objctYn === 'N') return;
    
    try {
      const { objctExmpCn = "", qstCransr = "" } = answeringQuestions.data;
      const objctExmpCns = objctExmpCn ? objctExmpCn.split(';') : [] // 보기문항
      const qstCransrs = qstCransr ? qstCransr.split(';') : []  // 정답문항

      setAnswerView(qstCransrs);
      // 문항을 합치고 랜덤돌림
      // console.log({ answeringQuestions });
      // 주제학습, 코스학습, 문항검수앱일 경우
      let randomAnswers = answeringQuestions.learningType || window.location.pathname.indexOf(URL.QUESTION_INSPECTION.ANSWERING_QUESTIONS) > -1
        ? objctExmpCns.concat(qstCransrs).sort(() => Math.random() - 0.5) 
        : answeringQuestions.data.wransrObjctExmpCn.split(';');

      if (answeringQuestions.randomMultipleAnswer && answeringQuestions.randomMultipleAnswer.length > 0) {
        randomAnswers = answeringQuestions.randomMultipleAnswer;
      } 
      setQuestions(randomAnswers);
      setAnsweringQuestions({ randomMultipleAnswer: randomAnswers });
    } catch (error) {
      console.log({ error });
    }

  }, [answeringQuestions.data]);

  const handleChange = useCallback((e) => {
    let result = [...answers];
    const value = e.target.value;

    if (result.indexOf(value) > -1) {
      _.remove(result, (v) => v === value);
    } else {

      if (answerView.length === 1 && result.length >= 1) {
        result = [value];
      } else {
        result.push(value);
      }

    }
    if (props?.onCount) props.onCount();
    setAnswers(result);
    setAnsweringQuestions({ multipleAnswer: result.join(';') });
  }, [answers]);

  const onSubmit = useCallback(() => {
    setAnsweringQuestions({ 
      objctExmpCn: questions.join(';'),
      randomMultipleAnswer: [],
    });

    if (answers.length === 0) {
      setAnsweringQuestions({ isShowNotEnteredAnswerPopup: true });
      return;
    }
    checkAnswer();
    if (window.location.pathname.indexOf("questionInspection/answeringQuestions") === -1) sendNotesLog();
    
  }, [answeringQuestions, answerView, questions])

  useEffect(() => {
    // console.log({ questions });
  }, [questions])

  return cloneElement(
    props.children || <React.Fragment />,
    {
      type: 'learning',
      questions: questions,
      answerView: answerView,
      answers: answers,
      answersQuestion: answeringQuestions.data,
      onSubmit: onSubmit,
      handleChange: handleChange,
      handleQestion: handleQestionRandom
    }
  )
}

export default MultipleChoiceQuestion;